import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import SpecLink from 'src/components/SpecLink';
import routes from 'src/routes';
import Page from 'src/components/Page';

function Txn2PartyPage() {
    return <Page header="2-Party">
        <p>
            There are two, 2-party transaction processing payment methods.  In this section the focus is on the 2-party transaction processing without the AuthKey.
            For transaction processing with an AuthKey, please go to <Link end to={routes.api.twoPartyTxnProcessing.root}>2-Party AuthKey</Link>.            
        </p>
        <h2>PCI DSS compliance</h2>
        <p>
            As with all 2-party transaction processing, you are responsible for meeting PCI-DSS compliance as payment details will be exposed to you.  Please refer 
            to <Link end to={routes.api.txn.authkey.overview}>2-Party AuthKey</Link> for more information.
        </p>
        <h2>Implementation</h2>
        <p>
            Processing a payment via 2-party transaction is straight forward.  You only need to make one API call 
            to <SpecLink uriFragment="#tag/Txn/operation/Txn_Process">Process transaction</SpecLink> with the payment details.
        </p>
    </Page>;
}

export default Txn2PartyPage;